import type { Experience } from '@/features/experiences/types/experience.types';
import type { WizardStepId } from '../types/candidate-wizard.types';

export type WizardCompletion = Record<WizardStepId, boolean>;

export type ContactCounts = Record<string, number>;

function hasContactForEveryExperience(
  experiences: Experience[],
  contactCounts: ContactCounts
): boolean {
  if (experiences.length === 0) return false;
  return experiences.every((experience) => (contactCounts[experience.id] ?? 0) > 0);
}

export function calculateWizardCompletion(
  experiences: Experience[],
  contactCounts: ContactCounts
): WizardCompletion {
  return {
    experience: hasContactForEveryExperience(experiences, contactCounts),
    review: false,
  };
}

export function findFirstIncompleteStep(completion: WizardCompletion): WizardStepId {
  if (!completion.experience) return 'experience';
  return 'review';
}
